import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { getPermissions, module, permission } from 'src/app/shared/models/userPermissions';
import { UserPermissionsService } from 'src/app/shared/services/user-permissions.service';
import { searchOrganization } from 'src/app/shared/models/organizations';
import { OrganizationsService } from 'src/app/shared/services/organizations.service';

@Component({
  selector: 'app-add-permissions',
  templateUrl: './add-permissions.component.html',
  styleUrls: ['./add-permissions.component.scss']
})
export class AddPermissionsComponent implements OnInit {
  @ViewChild('targetDiv', { static: false }) targetDiv!: ElementRef;

  userName: string= '';
  userNameArray: string[] = [];
  isLoading: boolean = false;
  permissionsByType: any = [];
  selectedPermissionIds: string[] = [];
  overallSelect: boolean = false;
  outlineUserName: boolean;
  outlineOrg: boolean;
  orgList: searchOrganization[] = [];
  organizationId: string= "" ;
  atleastOnePermission: boolean = false;
  hideSubmitBtn: boolean = false;
  errorText: boolean = false;
  selectedOrg: string;
  selectedDefaultPermission: string = "";
  permissionsForLabUsers: any[] = [
    {label: 'Default Learner Permission', value: 'Learner'},
    {label: 'Default Instructor Permission', value: 'Instructor'}
  ];
  defaultPermission: any[] = [];
  permissionType: string = "";

  constructor(
    private userPermissionsService: UserPermissionsService,
    private toasterService: ToastrService,
    private orgService: OrganizationsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getPermissionNames();
    this.searchOrganizations();
    this.selectedOrg = "";
  }

  async getPermissionNames() {
    this.isLoading = true;
    try {
      const payload: getPermissions = {
        userId: null,
        isUpdate: false
      }
      const result: any = await this.userPermissionsService.permissionNames(payload).toPromise();
      if (result.success) {
        const permissions = result.permissions[0].result.permissions;
        this.permissionsByType = Object.keys(permissions).map((key) => {
          return {
            type: key,
            permissions: permissions[key]
          };
        });
        this.isLoading = false;
      }
    }
    catch (err: any) {
      console.log(err);
      this.hideSubmitBtn = true;
      this.toasterService.error(err.error.message);
      this.isLoading = false;
    }
  }

  toggleSelectAll(module: module, event: any) {
    this.selectedDefaultPermission = "";
    const isChecked = event.target.checked;

    module.permissions.forEach((permission: permission) => {
      permission.hasPermission = isChecked;
    });

    this.updateOverallSelect();
  }

  changeStatus(module: any) {
    const allChecked = module.permissions.every((permission: permission) => permission.hasPermission);
    this.updateOverallSelect();
    return allChecked;
  }

  toggleOverallSelect(event: any) {
    this.selectedDefaultPermission = "";
    const isChecked = event.target.checked;
    this.permissionsByType.forEach((module: module) => {
      module.permissions.forEach((permission: permission) => {
        permission.hasPermission = isChecked;
      });
    });
  }

  updateOverallSelect() {
    this.overallSelect = this.permissionsByType.every((module: module) =>
      module.permissions.every((permission: permission) => permission.hasPermission)
    );
  }

  onFocus() {
    this.outlineUserName = false;
  }

  onOrgFocus() {
    this.outlineOrg = false;
  }

  
  onUserNameChange() {
    if (this.userName) {
      this.userNameArray = this.userName.split(',').map(name => name.trim()).filter(name => name.length > 0);
    } else {
      this.userNameArray = [];
    }
  }

  async onSubmit() {

    this.onUserNameChange();

    if (!this.userName) {
      this.targetDiv.nativeElement.scrollIntoView({ behavior: 'smooth' });
      // this.toasterService.error("Username is required");
      this.errorText = true;
      this.outlineUserName = true;
      return;
    }
    console.log(this.organizationId)
    if (this.organizationId === "") {
      this.outlineOrg = true;
      return
    }

    this.selectedPermissionIds = [];

    this.permissionsByType.forEach((module: module) => {
      module.permissions.forEach((permission: permission) => {
        if (permission.hasPermission) {
          this.selectedPermissionIds.push(permission.permissionId);
          this.atleastOnePermission = true;
        }
      });
    });

    if (!this.atleastOnePermission) {
      this.toasterService.error("Select atleast one Permission!");
      return;
    }

    try {
      this.isLoading = true;
      const payload = {
        users: this.userNameArray,
        permissions: this.selectedPermissionIds,
        organizationId: this.organizationId,
        permissionType: this.selectedDefaultPermission
      }
      const result: any = await this.userPermissionsService.createUserPermissions(payload).toPromise();
      this.toasterService.success(result.message);
      this.router.navigateByUrl('/admin/user-permissions')
      this.isLoading = false;
    }
    catch (err: any) {
      console.log(err);
      this.isLoading = false;
      this.toasterService.error(err.error.message);
    }
  }

  async searchOrganizations() {
    try {
      this.isLoading = true;
      const payload: searchOrganization = {
        isActive: true
      }
      const result: any = await this.orgService.search(payload).toPromise();
      this.isLoading = false;
      if (result && result.organizations.length > 0) {
        if(result && result.organizations.length === 1 ){
          this.selectedOrg = result.organizations[0].orgId;
          this.organizationId = result.organizations[0].orgId;
        }
        this.orgList = result.organizations;
      }
    } catch (e: any) {
      console.log(e);
      if (e.status == 403) {
        this.toasterService.error(e.error.message)
      }
    }
  }

  onChange(event: any) {
    console.log(event.target.value)
    if (event.target.value != "") {
      this.organizationId = event.target.value;
    } else {
      this.organizationId = "";
    }
  }

  async handleDefaultPermission(event: any) {
    this.isLoading = true;
    this.selectedDefaultPermission = event.target.value;  
    if (event.target.value == "Learner") {
      const learnerPermission: any = await this.userPermissionsService.getDefaultLearnerPermission().toPromise();
      if(learnerPermission.success){
        this.defaultPermission = learnerPermission.data;
        this.autoCheckPermissions();
      }
    } else if (event.target.value == "Instructor") {
      const instructorPermission: any = await this.userPermissionsService.getDefaultInstructorPermission().toPromise();
      if(instructorPermission.success){
        this.defaultPermission = instructorPermission.data;
        this.autoCheckPermissions();
      }
    } else {
      this.permissionType = "";
      this.defaultPermission = [];
      this.autoCheckPermissions();
    }
    this.isLoading = false;
  }
  
  autoCheckPermissions() {
    const defaultPermissionIds = this.defaultPermission.map((dp: any) => dp.permissionId);
    this.permissionsByType.forEach((module: any) => {
      module.permissions.forEach((permission: any) => {
        if (defaultPermissionIds.includes(permission.permissionId)) {
          permission.hasPermission = true;
        }else {
          permission.hasPermission = false;
        }
      });
    });
    this.updateOverallSelect();
    this.isLoading = false;
  }
  
  onCancel() {
    this.router.navigateByUrl('/admin/user-permissions')
  }

}
